import { CanvasRoutes } from '@/configs/routes/types';

export const OverviewRoutes = {
  [CanvasRoutes.Overview]: {
    name: 'Overview',
    path: '/overview',
    showInNavigation: true,
    showInBreadcrumbs: false,
  },
  [CanvasRoutes.OverviewHome]: {
    name: 'Home',
    path: '/overview/home',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.OverviewCycle]: {
    name: 'Cycle',
    path: '/overview/cycle',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.OverviewPerformance]: {
    name: 'Performance',
    path: '/overview/performance',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
};
